function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { legalTermsModel, serviceModel } from "../../models";
import { RelationshipProgressStatus, RelationshipStatus } from "../../models/relationship";
import { notEmpty } from "../../infra/utils";
import { businessSettingsDefaults } from "../../constants";
const defaultCreatedBy = {
  id: '',
  email: '',
  firstName: '',
  lastName: '',
  phone: null
};
export function getRelationshipFromDraft(data) {
  var _sampleContact$custom, _contactsMap$draft$cl;

  const {
    draft,
    sampleContact,
    contactsMap,
    legalTerms,
    userInfo = {},
    worksAt
  } = data;
  return _objectSpread(_objectSpread({}, draft), {}, {
    buyer: draft.isSample ? sampleContact : draft.clientContactId ? contactsMap[draft.clientContactId] : getDefaultBuyer(draft.buyerPhone),
    vendor: getVendor(worksAt),
    seller: getSeller(userInfo),
    customer: draft.isSample ? {
      id: (_sampleContact$custom = sampleContact.customerId) !== null && _sampleContact$custom !== void 0 ? _sampleContact$custom : '',
      name: sampleContact.companyName
    } : draft.clientContactId && contactsMap[draft.clientContactId] != null ? {
      id: (_contactsMap$draft$cl = contactsMap[draft.clientContactId].customerId) !== null && _contactsMap$draft$cl !== void 0 ? _contactsMap$draft$cl : '',
      name: contactsMap[draft.clientContactId].companyName
    } : getDefaultCustomer(draft.customerName),
    legalTerms: legalTerms.find(terms => {
      var _draft$legalTerms, _draft$legalTerms2;

      return ((_draft$legalTerms = draft.legalTerms) === null || _draft$legalTerms === void 0 ? void 0 : _draft$legalTerms.type) === 'libraryLegalTermsId' && terms.id === ((_draft$legalTerms2 = draft.legalTerms) === null || _draft$legalTerms2 === void 0 ? void 0 : _draft$legalTerms2.libraryLegalTermsId);
    }) || legalTermsModel.fromDraftLegalTerms(draft.legalTerms),
    services: draft.services.map(serviceModel.fromDTO).filter(notEmpty),
    serviceBundles: draft.serviceBundles ? {
      bundles: draft.serviceBundles.bundles.map(b => _objectSpread(_objectSpread({}, b), {}, {
        services: b.services.map(serviceModel.fromDTO).filter(notEmpty)
      }))
    } : undefined,
    amendmentsApprovalMethod: draft.amendmentsApprovalMethod || businessSettingsDefaults.amendmentsApprovalMethod,
    status: RelationshipStatus.Pending,
    createdOn: 0,
    automaticPaymentsEnabled: !!draft.requirePaymentMethod && !draft.allowManualPayments,
    version: '',
    signedOn: null,
    terminatedOn: null,
    paymentMethod: null,
    signature: null,
    approvalFlow: draft.isExistingCustomer ? 'invite' : 'proposal',
    suggestedCustomerName: null,
    invoiceStatus: {
      numPaymentActionRequired: 0,
      numRequiresPaymentApproval: 0
    },
    serviceStatus: {
      numAmended: 0
    },
    progressStatus: RelationshipProgressStatus.Sent,
    progressStatusTimestamp: 0,
    adHocChargeStatus: {
      numAwaitingApproval: 0
    },
    notificationStatus: [],
    createdBy: defaultCreatedBy,
    changes: null,
    statusTimestamp: 0,
    approvalRecord: {
      ip: '',
      signature: '',
      timestamp: 0
    }
  });
}
export function getSetupBrandRelationship(data) {
  var _worksAt$settings, _worksAt$settings2;

  const {
    legalTerms,
    userInfo,
    worksAt
  } = data;
  const legalTermsDocumentId = worksAt === null || worksAt === void 0 ? void 0 : (_worksAt$settings = worksAt.settings) === null || _worksAt$settings === void 0 ? void 0 : _worksAt$settings.legalTermsDocumentId;
  return {
    id: '',
    isSample: false,
    progressStatus: RelationshipProgressStatus.Sent,
    progressStatusTimestamp: 0,
    title: '',
    createdOn: 0,
    allowManualPayments: false,
    automaticPaymentsEnabled: true,
    approvalFlow: 'proposal',
    coverLetter: '',
    customNotificationText: (worksAt === null || worksAt === void 0 ? void 0 : (_worksAt$settings2 = worksAt.settings) === null || _worksAt$settings2 === void 0 ? void 0 : _worksAt$settings2.introductoryMessages.proposal) || businessSettingsDefaults.introductoryMessages.proposal,
    effectiveDate: null,
    extraClause: null,
    legalTerms: legalTermsDocumentId && legalTerms.find(term => term.id === legalTermsDocumentId) || legalTerms[0] || legalTermsModel.makePdfLegalTerms({
      name: '',
      pdfUniqueName: ''
    }),
    netTerms: 0,
    services: [],
    signedOn: null,
    status: RelationshipStatus.Pending,
    suggestedCustomerName: null,
    signature: null,
    statusTimestamp: 0,
    terminatedOn: null,
    changes: null,
    version: '',
    paymentMethod: null,
    requirePaymentMethod: true,
    adHocChargeStatus: {
      numAwaitingApproval: 0
    },
    invoiceStatus: {
      numPaymentActionRequired: 0,
      numRequiresPaymentApproval: 0
    },
    serviceStatus: {
      numAmended: 0
    },
    amendmentsApprovalMethod: businessSettingsDefaults.amendmentsApprovalMethod,
    customer: getDefaultCustomer(),
    vendor: getVendor(worksAt),
    buyer: getDefaultBuyer(null),
    clientContactId: null,
    createdBy: defaultCreatedBy,
    feeControls: {
      coverCreditCardFees: false,
      coverDirectDebitFees: false
    },
    notificationStatus: [],
    seller: getSeller(userInfo)
  };
}

function getVendor(worksAt) {
  const {
    branding,
    id,
    logoUrl,
    name,
    postalAddress
  } = worksAt !== null && worksAt !== void 0 ? worksAt : {};
  const {
    addressOne,
    addressTwo,
    city,
    country,
    postalCode,
    state
  } = postalAddress !== null && postalAddress !== void 0 ? postalAddress : {};
  return {
    branding: branding || {
      color: ''
    },
    id: id || '',
    logoUrl: logoUrl || null,
    name: name || '',
    stripeAccountId: '',
    postalAddress: {
      addressOne: addressOne || null,
      addressTwo: addressTwo || null,
      city: city || null,
      country: country || null,
      postalCode: postalCode || null,
      state: state || null
    }
  };
}

function getSeller(userInfo) {
  const user = userInfo !== null && userInfo !== void 0 ? userInfo : {};
  return {
    id: user.id || '',
    firstName: user.firstName || null,
    lastName: user.lastName || null,
    email: user.email || '',
    phone: user.phone || null
  };
}

function getDefaultBuyer(phone) {
  return {
    id: '',
    email: '',
    firstName: 'First name',
    lastName: 'Last name',
    phone
  };
}

function getDefaultCustomer(name) {
  return {
    id: '',
    name: name !== null && name !== void 0 ? name : 'Company name'
  };
}